import { faFacebook, faInstagram, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faLocation, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as GymLogo } from '../assets/images/Privategym_schijndel_logo.svg';

const Footer = () => {
    return (
        <section className="footer pb-20">
            <div className="default-container">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-x-12 gap-y-8 md:gap-y-0">
                    <div className="flex flex-col space-y-2">
                        <Link to={''}><GymLogo
                            className="h-full w-full md:w-2/3 transition-colors hover:fill-primary-300"/></Link>
                        <hr className="primary-hr"/>
                        <Link to={'/privacy-statement'}>Privacyverklaring</Link>
                        <Link to={'/terms-and-conditions'}>Algemene voorwaarden</Link>
                        <div className="pt-4">Copyright © {new Date().getFullYear()}</div>
                        <div className="pt-4 flex flex-wrap gap-5 text-3xl text-primary-500">
                            <Link target="_blank" to={'https://www.instagram.com/privategym.schijndel/'}>
                                <FontAwesomeIcon icon={faInstagram}/>
                            </Link>
                            <Link target="_blank" to="https://www.facebook.com/privategymschijndel">
                                <FontAwesomeIcon icon={faFacebook}/>
                            </Link>
                            <Link target="_blank" to="https://www.linkedin.com/in/nick-van-schijndel-0528a0139/?originalSubdomain=nl">
                                <FontAwesomeIcon icon={faLinkedin}/>
                            </Link>
                            <Link target="_blank" to="https://www.researchgate.net/profile/Nick-Van-Schijndel">
                                <span className="font-bold text-2xl leading-none">RG</span>
                            </Link>
                            <Link to={'https://wa.me/+31683371313'}>
                                <FontAwesomeIcon icon={faWhatsapp}/>
                            </Link>
                        </div>
                    </div>

                    <div className="flex flex-col space-y-2">
                        <h4 className="pb-4">Navigeer direct</h4>
                        <Link to={'/concept'}>Over Private Gym Schijndel</Link>
                        <Link to={'/about'}>Over Nick</Link>
                        <Link to={'/rooms'}>De gym</Link>
                        <Link to={'/membership'}>Kies een lidmaatschap</Link>
                        <Link to={'/contact'}>Direct contact opnemen</Link>
                        <Link to={'/faq'}>Vaak gestelde vragen</Link>
                        <Link to={'/pictures'}>Impressies</Link>
                    </div>

                    <div className="flex flex-col space-y-2 col-span-2 md:col-span-1">
                        <h4 className="pb-4">Neem contact op</h4>
                        <div><span className="text-primary-500 pr-2">{<FontAwesomeIcon
                            icon={faLocation}/>}</span> Ericastraat 3, Schijndel, 5482
                            WR
                        </div>
                        <a href="tel:+31683371313"><span
                            className="text-primary-500 pr-2">{<FontAwesomeIcon icon={faPhone}/>}</span> +31 6 8337 1313</a>
                        <a href="mailto:info@privategym-schijndel.nl"><span
                            className="text-primary-500 pr-2">{<FontAwesomeIcon
                            icon={faEnvelope}/>}</span> info@privategym-schijndel.nl</a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Footer;
